/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */
import PropTypes from 'prop-types';
import {css} from 'styled-components';
import {map} from 'styled-components-breakpoint';
import {ResponsiveOrStaticProp, Nullable} from './../../utils';

// Flex Direction:

export const validFlexDirectionValues = ['row', 'column', 'row-reverse', 'column-reverse'] as const;
export type flexDirectionValues = typeof validFlexDirectionValues[number];

export type FlexDirectionType = ResponsiveOrStaticProp<Nullable<flexDirectionValues>>;

export const flexDirection = (props: any) => css`
  ${({flexDirection}: {flexDirection: FlexDirectionType}) =>
    map(
      flexDirection,
      (val: flexDirectionValues) =>
        val &&
        css`
          flex-direction: ${val};
        `
    )};
`;

export const flexDirectionPropType = PropTypes.oneOf(validFlexDirectionValues);
export const flexDirectionPropTypeMap = PropTypes.oneOfType([
  flexDirectionPropType,
  PropTypes.shape({
    xs: flexDirectionPropType,
    sm: flexDirectionPropType,
    md: flexDirectionPropType,
    lg: flexDirectionPropType,
    xl: flexDirectionPropType,
    xxl: flexDirectionPropType,
    xxxl: flexDirectionPropType
  })
]);

// Flex Wrap:

export const validFlexWrapValues = ['wrap', 'nowrap'] as const;
export type flexWrapValues = typeof validFlexWrapValues[number];

export type FlexWrapType = ResponsiveOrStaticProp<Nullable<flexWrapValues>>;

export const flexWrap = (props: any) => css`
  ${({flexWrap}: {flexWrap: FlexWrapType}) =>
    map(
      flexWrap,
      (val: flexWrapValues) =>
        val &&
        css`
          flex-wrap: ${val};
        `
    )};
`;

export const flexWrapPropType = PropTypes.oneOf(validFlexWrapValues);
export const flexWrapPropTypeMap = PropTypes.oneOfType([
  flexWrapPropType,
  PropTypes.shape({
    xs: flexWrapPropType,
    sm: flexWrapPropType,
    md: flexWrapPropType,
    lg: flexWrapPropType,
    xl: flexWrapPropType,
    xxl: flexWrapPropType,
    xxxl: flexWrapPropType
  })
]);

// Flex Grow and Shrink

export type FlexGrowShrinkType = ResponsiveOrStaticProp<Nullable<number>>;

export const flexGrow = (props: any) => css`
  ${({flexGrow}: {flexGrow: FlexGrowShrinkType}) =>
    map(
      flexGrow,
      (val: number) =>
        val !== undefined &&
        css`
          flex-grow: ${val};
        `
    )};
`;

export const flexShrink = (props: any) => css`
  ${({flexShrink}: {flexShrink: FlexGrowShrinkType}) =>
    map(
      flexShrink,
      (val: number) =>
        val !== undefined &&
        css`
          flex-shrink: ${val};
        `
    )};
`;

export const flexGrowShrinkPropType = PropTypes.number;

export const flexGrowPropTypeMap = PropTypes.oneOfType([
  flexGrowShrinkPropType,
  PropTypes.shape({
    xs: flexGrowShrinkPropType,
    sm: flexGrowShrinkPropType,
    md: flexGrowShrinkPropType,
    lg: flexGrowShrinkPropType,
    xl: flexGrowShrinkPropType,
    xxl: flexGrowShrinkPropType,
    xxxl: flexGrowShrinkPropType
  })
]);

export const flexShrinkPropTypeMap = PropTypes.oneOfType([
  flexGrowShrinkPropType,
  PropTypes.shape({
    xs: flexGrowShrinkPropType,
    sm: flexGrowShrinkPropType,
    md: flexGrowShrinkPropType,
    lg: flexGrowShrinkPropType,
    xl: flexGrowShrinkPropType,
    xxl: flexGrowShrinkPropType,
    xxxl: flexGrowShrinkPropType
  })
]);

// Align Items:

export const validAlignItemsValues = ['center', 'flex-start', 'flex-end'] as const;
export type alignItemsValues = typeof validAlignItemsValues[number];

export type AlignItemsType = ResponsiveOrStaticProp<Nullable<alignItemsValues>>;

export const alignItems = (props: any) => css`
  ${({alignItems}: {alignItems: AlignItemsType}) =>
    map(
      alignItems,
      (val: alignItemsValues) =>
        val &&
        css`
          align-items: ${val};
        `
    )};
`;

export const alignItemsPropType = PropTypes.oneOf(validAlignItemsValues);
export const alignItemsPropTypeMap = PropTypes.oneOfType([
  alignItemsPropType,
  PropTypes.shape({
    xs: alignItemsPropType,
    sm: alignItemsPropType,
    md: alignItemsPropType,
    lg: alignItemsPropType,
    xl: alignItemsPropType,
    xxl: alignItemsPropType,
    xxxl: alignItemsPropType
  })
]);

// Justify Content:

export const validJustifyContentValues = ['center', 'flex-start', 'flex-end'] as const;
export type justifyContentValues = typeof validJustifyContentValues[number];

export type JustifyContentType = ResponsiveOrStaticProp<Nullable<justifyContentValues>>;

export const justifyContent = (props: any) => css`
  ${({justifyContent}: {justifyContent: JustifyContentType}) =>
    map(
      justifyContent,
      (val: justifyContentValues) =>
        val &&
        css`
          justify-content: ${val};
        `
    )};
`;

export const justifyContentPropType = PropTypes.oneOf(validJustifyContentValues);
export const justifyContentPropTypeMap = PropTypes.oneOfType([
  justifyContentPropType,
  PropTypes.shape({
    xs: justifyContentPropType,
    sm: justifyContentPropType,
    md: justifyContentPropType,
    lg: justifyContentPropType,
    xl: justifyContentPropType,
    xxl: justifyContentPropType,
    xxxl: justifyContentPropType
  })
]);
